import { render } from "./HelloWorld.vue?vue&type=template&id=62e3f08a&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=62e3f08a&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-62e3f08a"

export default script